export default "__VITE_ASSET__CdGVULD5__"